import { render, staticRenderFns } from "./UserViewCauseList.vue?vue&type=template&id=53a748ce"
import script from "./UserViewCauseList.vue?vue&type=script&lang=js"
export * from "./UserViewCauseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports